export type PatientFamilyRelative = {
  name: string;
  relation?: string;
  profession?: string;
};

export function normalizePatientFamilyRelatives(raw: unknown): PatientFamilyRelative[] {
  if (!Array.isArray(raw)) return [];
  const out: PatientFamilyRelative[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;
    const name = String((item as PatientFamilyRelative).name || '').trim();
    if (!name) continue;
    const relation = String((item as PatientFamilyRelative).relation || '').trim();
    const profession = String((item as PatientFamilyRelative).profession || '').trim();
    out.push({
      name,
      ...(relation ? { relation } : {}),
      ...(profession ? { profession } : {}),
    });
  }
  return out;
}

export type PatientFamilyOverviewSource = {
  mother_name?: string | null;
  father_name?: string | null;
  family_relatives?: unknown;
  companion_name?: string | null;
  companion_relation?: string | null;
  guardian_name?: string | null;
  guardian_cpf?: string | null;
  guardian_phone?: string | null;
  guardian_relation?: string | null;
};

export function patientHasFamilyOverviewData(patient: PatientFamilyOverviewSource): boolean {
  if (String(patient.mother_name || '').trim()) return true;
  if (String(patient.father_name || '').trim()) return true;
  if (normalizePatientFamilyRelatives(patient.family_relatives).length > 0) return true;
  if (String(patient.companion_name || '').trim() || String(patient.companion_relation || '').trim()) return true;
  if (
    String(patient.guardian_name || '').trim()
    || String(patient.guardian_cpf || '').trim()
    || String(patient.guardian_phone || '').trim()
    || String(patient.guardian_relation || '').trim()
  ) return true;
  return false;
}

export function sanitizeFamilyRelativesForSave(raw: unknown): PatientFamilyRelative[] {
  return normalizePatientFamilyRelatives(raw).slice(0, 30);
}
